import { useEffect, useState } from "react";
import FollowTheLine from "./FollowTheLine";

export default function Level5_TrailBlazers(props) {
  const levels = [
    { id: "Level4", label: "Level 1", len: 5},
    { id: "Level5", label: "Level 2", len: 4},
    { id: "Level6", label: "Level 3", len: 3}
  ];
  
  return (
    <FollowTheLine {...props} levels={levels} />
  );
}

